export default function CTASection() {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Top%20down%20view%20of%20a%20vibrant%20colorful%20flat%20lay%20with%20fashion%20accessories%20shoes%20notebook%20and%20smartphone%20on%20white%20marble%20surface%2C%20bright%20diffused%20natural%20light%2C%20cheerful%20modern%20composition%2C%20warm%20peach%20and%20mint%20accents%2C%20editorial%20ecommerce%20aesthetic%2C%20positive%20uplifting%20mood&width=1800&height=1000&seq=cta-v2-bg&orientation=landscape"
          alt="Start using ACBuy Spreadsheet today"
          title="Start using ACBuy Spreadsheet now"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/25 to-black/35"></div>
      </div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 tracking-wide mb-3 md:mb-4">
          READY TO SHOP SMARTER?
        </h2>
        <p className="text-sm md:text-base text-background-50/80 max-w-xl mb-6 md:mb-8 leading-relaxed">
          Start using the <strong>acbuyspreadsheet</strong> system now and compare thousands
          of products instantly with complete pricing transparency.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-7 py-3.5 bg-foreground-950 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-foreground-900 transition-all duration-200 whitespace-nowrap cursor-pointer group"
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 text-foreground-950">
            <i className="ri-shopping-bag-line text-sm"></i>
          </span>
          <span>ACCESS ACBUY SPREADSHEET</span>
          <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
        </a>
      </div>
    </section>
  );
}